import cx from 'classnames';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { logger, SettingsManager, SiteConfigManager, TranslationProvider } from '@apollo/core';
import { onSignUpSubmit, useActiveForm } from '@apollo/react-forms';
import CordovaProvider from '../../../core/Cordova/CordovaProvider';
import SignUpForm from '../SignUp/SignUpForm';
import StaticBlock from '../StaticBlock/StaticBlock';
import { cmsStaticBlock } from '../../../core/constants';

const AffiliatePage = () => {
  const routeParams = useParams();
  const { affiliateId = '' } = routeParams;

  const classes = cx('affiliate-page', `affiliate-page--${String(affiliateId).toLowerCase()}`);
  const activeForm = useActiveForm('CLIENT_REGISTRATION', onSignUpSubmit);

  useEffect(() => {
    localStorage.setItem('affiliateId', String(affiliateId).toLowerCase());
  }, [affiliateId]);

  useEffect(() => {
    const init = async () => {
      Promise.all([
        await SiteConfigManager.resolveCmsConfig(),
        await SettingsManager.resolveSettings(),
      ])
        .then(() => {
          logger.debug('zzz - application is ready.');
        })
        .catch((error) => {
          // console.log('zzz - application is NOT ready.');
          logger.error('[GlobalSettingsLoader]', 'unable to resolve initial settings', error);
        });
    };
    init();
  }, []);

  return (
    <CordovaProvider>
      <TranslationProvider>
        <div className={classes}>
          <header className='affiliate-page__header'>
            <div className='affiliate-page__container'>
              <StaticBlock
                className='affiliate-page__header-static'
                options={{ source: cmsStaticBlock.AffiliateHeader }}
              />
            </div>
          </header>
          <main className='affiliate-page__body'>
            <div className='affiliate-page__container'>
              <SignUpForm activeForm={activeForm} />
            </div>
          </main>
          <footer className='affiliate-page__footer'>
            <div className='affiliate-page__container'>
              <StaticBlock
                className='affiliate-page__footer-static'
                options={{ source: cmsStaticBlock.Footer }}
              />
            </div>
          </footer>
        </div>
      </TranslationProvider>
    </CordovaProvider>
  );
};

export default AffiliatePage;
